type PaginationBarProps = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  itemLabel?: string;
};

export function PaginationBar({
  page,
  pageSize,
  total,
  onPageChange,
  itemLabel = "条记录"
}: PaginationBarProps) {
  if (total <= 0) return null;

  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const rangeStart = (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, total);

  return (
    <nav className="pagination-bar" aria-label={`${itemLabel}翻页`}>
      <span>
        共 <strong>{total}</strong> {itemLabel} · 当前第 {rangeStart}–{rangeEnd} 条
      </span>
      <div>
        <button
          type="button"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          上一页
        </button>
        <output aria-live="polite">第 {currentPage} / {totalPages} 页</output>
        <button
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          下一页
        </button>
      </div>
    </nav>
  );
}
